
import ScoreboardList from "@/components/ScoreboardList.vue";
import { mapGetters } from "vuex";

export default {
  name: "dashboard",
  data () {
    return {
      search: "",
      filter_us: true,
      filter_uk: false,
      services: {},
      serviceProducts: [],
      softwareProducts: ["EchoGo Core", "EchoGo Heart Failure", "EchoGo Amyloidosis"],
      products: {
        "EchoGo Core": true,
        "EchoGo Heart Failure": true,
        "EchoGo Amyloidosis": true
      }
    };
  },
  created () {
    this.$store.dispatch("refreshScoreboard");
    this.$store.dispatch("setServiceTypes", this.overview);
    this.setDefaultCheckbox();
    this.serviceProducts = this.retrieveServiceProducts();
  },
  computed: {
    orders () {
      const search = this.search?.toLowerCase() || "";
      let studies = JSON.parse(JSON.stringify(this.scoreboard));

      studies = this.setFirstResult(studies);

      // filter studies by their service/product against the values in serviceProducts array e.g Service, Demo etc
      const filteredStudiesByService = studies.filter(
        (study) => this.serviceProducts.includes(study.service) === true
      );

      const filteredStudies = [];
      if (Object.keys(this.products).length !== 0) {
        // filter studies by their software against the values in softwareProducts array e.g EchoGo Pro, EchoGo Heart Failure etc
        filteredStudiesByService.forEach((study) => {
          study.results.forEach((studyResult) => {
            // add studyResult to array if studyResult.software is included in selectedProduct
            if (this.hasCheckedProduct(studyResult.software) && !filteredStudies.includes(study)) {
              filteredStudies.push(study);
            }
          });
          // Planned, Preflight and Open studies oftentimes have no results/reports
          if (study.results.length === 0) {
            if (this.hasCheckedProduct(study.service) && !filteredStudies.includes(study)) {
              filteredStudies.push(study);
            }
          }
        });
      }

      // apply the filter
      return filteredStudies.filter((study) => {
        let wanted =
          study.customer?.toLowerCase().includes(search) ||
          study.accession?.toLowerCase().includes(search);

        if (study.service.indexOf("UK") > 0 && !this.filter_uk) {
          wanted = false;
        }
        if (study.service.indexOf("UK") === -1 && !this.filter_us) {
          wanted = false;
        }

        return wanted;
      });
    },
    ...mapGetters({
      apiError: "getAPIError",
      scoreboard: "getScoreboard",
      overview: "getOverview",
      serviceTypes: "getServiceTypes"
    })
  },
  methods: {
    setDefaultCheckbox () {
      // by default the service checkbox should be ticked if it exists
      const isServicePresent = this.serviceTypes.some(
        (item) => item.readable === "Service"
      );
      if (isServicePresent) {
        this.services = { Service: true };
      }
    },
    setFirstResult (studies: any) {
      studies.forEach(study => {
        study.first_result = study.results
          .map(e => e.sent_dt)
          .find(e => e !== "");
      });
      return studies;
    },
    removeFalseValues (collection: object) {
      for (const item in collection) {
        if (collection[item] === false) {
          delete collection[item];
        }
      }
    },
    retrieveServiceProducts () {
      // retrieve the product names for all services that are checked
      const serviceProducts = [];
      for (const service in this.services) {
        const serviceObject = this.serviceTypes.filter(
          (serviceType) => serviceType.readable === service
        );
        if (serviceObject[0].services.length > 1) {
          for (let c = 0; c < serviceObject[0].services.length; c++) {
            serviceProducts.push(serviceObject[0].services[c].name);
          }
        } else {
          serviceProducts.push(serviceObject[0].services[0].name);
        }
      }
      return serviceProducts;
    },
    hasCheckedProduct (software: string) {
      if (software in this.products) {
        return this.products[software];
      } else {
        return false;
      }
    }
  },
  watch: {
    services: {
      deep: true,
      handler () {
        this.removeFalseValues(this.services);
        this.serviceProducts = this.retrieveServiceProducts();
      }
    },
    products: {
      deep: true,
      handler () {
        this.removeFalseValues(this.products);
      }
    }
  },
  components: {
    ScoreboardList
  }
};
